import DocumentDownloadFactory from "../Factory/DocumentDownloadFactory";

const documentDownloadFactory: DocumentDownloadFactory = new DocumentDownloadFactory()

export default function getDocumentDownloadFactory(): DocumentDownloadFactory {
    return documentDownloadFactory;
}